import React, { useRef } from 'react'
import { useSprings, animated } from '@react-spring/web'
import { useDrag } from 'react-use-gesture'
import clamp from 'lodash.clamp'
import swap from 'lodash-move'
import {Container} from './Upload-Image/Container'

import styles from './Sidebar.module.css'

const fn = (order: number[], active = false, originalIndex = 0, curIndex = 0, y = 0) => (index: number) =>
    active && index === originalIndex
        ? {
            y: curIndex * 50 + y,
            scale: 1.1,
            zIndex: 1,
            shadow: 15,
            immediate: (key: string) => key === 'y' || key === 'zIndex',
        }
        : {
            y: order.indexOf(index) * 50,
            scale: 1,
            zIndex: 0,
            shadow: 1,
            immediate: false,
        }

function DraggableList({ items }: { items: string[] }) {
    const order = useRef(items.map((_, index) => index))
    const [springs, api] = useSprings(items.length, fn(order.current))
    const bind = useDrag(({ args: [originalIndex], active, movement: [, y] }) => {
        const curIndex = order.current.indexOf(originalIndex)
        const curRow = clamp(Math.round((curIndex * 100 + y) / 100), 0, items.length - 1)
        const newOrder = swap(order.current, curIndex, curRow)
        api.start(fn(newOrder, active, originalIndex, curIndex, y))
        if (!active) order.current = newOrder
    })
    return (
        <div className={styles.content} style={{ height: items.length * 50 }}>
            {springs.map(({ zIndex, shadow, y, scale }, i) => (
                <animated.div
                    {...bind(i)}
                    key={i}
                    style={{
                        zIndex,
                        boxShadow: shadow.to(s => `rgba(0, 0, 0, 0.15) 0px ${s}px ${2 * s}px 0px`),
                        y,
                        scale,
                    }}
                    children={items[i]}
                />
            ))}

        </div>
    )
}

const Sidebar = () =>{
    const triggerText = 'Open form';
    const onSubmit = (e: { preventDefault: (arg0: any) => void; target: { name: { value: any }; email: { value: any } } }) => {
        e.preventDefault(e);
        console.log(e.target.name.value);
        console.log(e.target.email.value);
    };
    return (
        <div>
            <div className={styles.sidebar}>
                <h2 className={styles.filter}>Categories</h2>

                <div className={styles.container}>
                    <DraggableList items={'ANIMALS PHOTOGRAPHY NATURE LANDCAPE Lorem ipsum dolor sit'.split(' ')} />
                </div>
                <div className={styles.upload}>
                    <Container triggerText={triggerText} onSubmit={onSubmit} />
                </div>
            </div>
        </div>
    )
}

export default Sidebar;